import { render, staticRenderFns } from "./CreateSingleUser.vue?vue&type=template&id=bb8e6308&scoped=true"
import script from "./CreateSingleUser.vue?vue&type=script&lang=js"
export * from "./CreateSingleUser.vue?vue&type=script&lang=js"
import style0 from "./CreateSingleUser.vue?vue&type=style&index=0&id=bb8e6308&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8e6308",
  null
  
)

export default component.exports